import { render, staticRenderFns } from "./stu-elogs.vue?vue&type=template&id=48c55a91&"
import script from "./stu-elogs.vue?vue&type=script&lang=js&"
export * from "./stu-elogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports